import { Space } from 'antd';
import { useEffect } from 'react';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Text } from '@atom/typography/typography';
import { ConnectorServiceEnum } from '@enum/connector-service.enum';
import { ColorEnum } from '@enum/style/color.enum';
import { IntegrationAuthForm } from '@form/integration-auth/integration-auth.form';
import { useStoreSelector } from '@hook/store/store.hooks';
import { ConnectionStateEnum } from '@interface/connection/connection.interface';
import { BaseFormInterface } from '@interface/form/base-form.interface';
import { isExist, isString } from '@util/data/is-exist';

import { Wrapper } from './integration-auth.style';

interface IntegrationAuthProps extends BaseFormInterface {
  serviceId: ConnectorServiceEnum;
  onEnable: (enabled: boolean) => void;
}

export const IntegrationAuth = ({ form, serviceId, onEnable }: IntegrationAuthProps) => {
  const connections = useStoreSelector((state) => state.connections.data);
  const data = connections[serviceId];

  useEffect(() => void (isExist(data) && form.setFieldsValue(data)), [data]);

  const hasUrl = isString(data?.authorizeUrl);

  return (
    <Wrapper>
      {!hasUrl && (
        <Text color={ColorEnum.Black100} level='m' paragraph>
          Note: Connector requires `Client Id` & `Client Secret`
        </Text>
      )}
      <Space>
        <Button disabled={!hasUrl} href={data?.authorizeUrl ?? ''} type={ButtonTypeEnum.Primary} ghost>
          {data.state === ConnectionStateEnum.Callable ? 'Re-Authorize' : 'Authorize'}
        </Button>
      </Space>
      <Space>
        <IntegrationAuthForm form={form} onEnable={onEnable} />
      </Space>
    </Wrapper>
  );
};
